import { InfoCircleFilled } from '@ant-design/icons';

const WarningMessage = () => {
    return (
        <div
            style={{
                backgroundColor: 'var(--orange-1)',
                border: '1px solid var(--orange-3)',
                borderRadius: 6,
                padding: '12px 16px',
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' }}>
                <InfoCircleFilled style={{ color: 'var(--orange-6)', fontSize: 16 }} />
                <span>
                    This manifest contains live declarations. To apply the changes, we will submit a bulk amendment for
                    all affected jobs and declarations.
                </span>
            </div>
        </div>
    );
};

export default WarningMessage;
